module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-underline-c3ffcfa599f557a8bb3801c1a4c2e1e4.svg";